<template>
  <div v-show="this.$store.state.hasConselor">
    <div class="to-consultant" v-show="isShow" @click="onClick">
      <span class="iconfont">&#xe65a;</span>
    </div>
    <transition name="fade">
      <div class="square" v-show="!isShow">
        <div class="call-consultant" @click="$router.push('/consultant/counserlor')">
          <span>联系借款顾问</span>
        </div>
        <div @click="onClick">
          <span class="iconfont">&#xe65a;</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      consultants: {
        type: Array
      }
    },
    data () {
      return {
        isShow: true
      }
    },
    methods: {
      onClick () {
        this.isShow = !this.isShow
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .to-consultant
    width 60px
    height 60px
    background #4AABF5
    border-radius 50%
    position fixed
    left 4px
    top 60%
    margin-top -30px
    z-index 99
    &:hover
      cursor pointer
    .iconfont
      width 18px
      height 18px
      position absolute
      left 21px
      top 21px
      color #fff
      transform rotate(-90deg)
      -ms-transform rotate(-90deg)
  .square
    width 190px
    height 44px
    background #2b9efc
    position fixed
    left 0
    top 60%
    margin-top -22px
    z-index 999
    text-align center
    border-radius: 3px;
    &:hover
      cursor pointer
      background #0068b7
    .call-consultant
      width 145px
      height 44px
      color #ffffff
      font-size 14px
      letter-spacing 3px
      line-height 44px
      display inline-block
      text-align center
      border-right 1px solid rgba(255,255,255,.5)
      span
        position: relative;
        left: -7px;
    .iconfont
      width 18px
      height 18px
      position absolute
      top 14px
      right 3px
      color #fff
      display inline-block
      transform rotate(90deg)
      -ms-transform rotate(90deg)
  .fade-enter-active,.fade-leave-active
    transition all .2s linear
  .fade-enter,.fade-leave-active
    opacity 0
    transform translateX(-190px)
</style>




// WEBPACK FOOTER //
// floating.vue?4957156a